import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import type { DataItemPayload } from 'src/types/global'

interface DataExplorerState {
  selectedItem?: DataItemPayload
}

const initialState: DataExplorerState = {}

const dataExplorerSlice = createSlice({
  name: 'dataExplorer',
  initialState,
  reducers: {
    selectDataItem(state, action: PayloadAction<DataItemPayload | undefined>) {
      state.selectedItem = action.payload
    }
  }
})

export const { selectDataItem } = dataExplorerSlice.actions
export default dataExplorerSlice.reducer
